export const extractTextFromReactNode = (node) => {
    if (typeof node === "string") {
        return node;
    }
    else if (typeof node === "number") {
        return node.toString();
    }
    else if (typeof node === "boolean") {
        return node ? "true" : "false";
    }
    else if (typeof node === "object" &&
        node &&
        "props" in node &&
        node.props &&
        typeof node.props === "object" &&
        "children" in node.props &&
        node.props.children) {
        return extractTextFromReactNode(node.props.children);
    }
    return "";
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0cmFjdFRleHRGcm9tUmVhY3ROb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpYi9leHRyYWN0VGV4dEZyb21SZWFjdE5vZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFxQixFQUFVLEVBQUU7SUFDeEUsSUFBSSxPQUFPLElBQUksS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM3QixPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7U0FBTSxJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQ3BDLE9BQU8sSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFDO0lBQ3pCLENBQUM7U0FBTSxJQUFJLE9BQU8sSUFBSSxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ3JDLE9BQU8sSUFBSSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQztJQUNqQyxDQUFDO1NBQU0sSUFDTCxPQUFPLElBQUksS0FBSyxRQUFRO1FBQ3hCLElBQUk7UUFDSixPQUFPLElBQUksSUFBSTtRQUNmLElBQUksQ0FBQyxLQUFLO1FBQ1YsT0FBTyxJQUFJLENBQUMsS0FBSyxLQUFLLFFBQVE7UUFDOUIsVUFBVSxJQUFJLElBQUksQ0FBQyxLQUFLO1FBQ3hCLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUNuQixDQUFDO1FBQ0QsT0FBTyx3QkFBd0IsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQTJCLENBQUMsQ0FBQztJQUMxRSxDQUFDO0lBQ0QsT0FBTyxFQUFFLENBQUM7QUFDWixDQUFDLENBQUMifQ==